import { Button } from "@mui/material";
import React, { useState } from "react";
import { formatter } from "../Common/commonUtils";
import VoucherBox from "./VoucherBox";
import { getCaterCashSummary } from "./cater-cash.utils";
export default function CaterCashSummery(props) {
  const [openVoucherBox,setOpenVoucherBox] = useState(false)
  const [selectedAmount,setSelectedAmount]= useState('')
  const totals = getCaterCashSummary(
    props?.caterCashTotal?.listCaterCashTotal,
  );
  const isCustomerAccount =
    props?.userType === "Customer" || props?.customerAccount;

  return (
    <div>
      {props?.userType === "Customer" && (
        <VoucherBox
          openVoucherBox={openVoucherBox}
          setOpenVoucherBox={setOpenVoucherBox}
          selectedAmount={selectedAmount}
          setSelectedAmount={setSelectedAmount}
          setVoucherData={props?.setVoucherData}
        />
      )}
      {isCustomerAccount ? (
        <div className="catercash-overview">
          <div className="cc-item cc-total">
           <h2>{formatter.format(totals.distributed)}</h2>
            <div className="d-md-flex cc-item-inner align-items-center">
              <img
                src="../assets/images/catercashsum.svg"
                className="img-fluid"
                alt="Icon"
              /><label>Total CaterCash Distributed</label>
            </div>

          </div>
          <div className="cc-item cc-redeemed">
           <h2>{formatter.format(totals.redeemed)}</h2>
            <div className="d-md-flex cc-item-inner align-items-center">
              <img
                src="../assets/images/redeemed.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>Redeemed CaterCash</label>
            </div>
          </div>

          <div className="cc-item cc-current">
            <h2>{formatter.format(totals.outstanding)}</h2>
            <div className="d-md-flex cc-item-inner align-items-center">
              <img
                src="../assets/images/current.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>Outstanding CaterCash</label>
            </div>
          </div>

          <div className="cc-item cc-expired">
            <h2>
              {formatter.format(
                props?.customerAccount ? totals.retracted : totals.expired,
              )}
            </h2>
            <div className="d-md-flex cc-item-inner align-items-center">
              <img
                src="../assets/images/expired.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>
                {props?.customerAccount
                  ? "Retracted CaterCash"
                  : "Expired CaterCash"}
              </label>
            </div>
          </div>

          {props?.userType === "Customer" && (
            <div className="cc-item cc-gift">
              <img src="../assets/images/amazon.svg" className="img-fluid" alt="Amazon Gift"/>
              <small>Choose a Value to Redeem Your CaterCash</small>
              <div className="amazon-btn">
                <Button variant={"contained"} onClick={()=>{setOpenVoucherBox(true);setSelectedAmount(10)}}>$10</Button>
                <Button variant={"contained"} onClick={()=>{setOpenVoucherBox(true);setSelectedAmount(25)}}>$25</Button>
                <Button variant={"contained"} onClick={()=>{setOpenVoucherBox(true);setSelectedAmount(50)}}>$50</Button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="catercash-overview">
          <div className="cc-item cc-gift">
            {props?.totalData?.getCaterCashBalance&&<h2>{formatter.format(props?.totalData?.getCaterCashBalance?.caterCashBalance)}</h2>}
            <div className="d-flex  align-items-center">
              <img
                src="../assets/images/amazon-icon.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>Amazon Gift Card Balance</label>
            </div>
          </div>
          <div className="cc-item cc-total">
            <h2>{formatter.format(totals.distributed - totals.gifted)}</h2>
            <div className="d-flex align-items-center">
              <img
                src="../assets/images/earnedcash.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>CaterCash Earned</label>
            </div>
          </div>

          <div className="cc-item  cc-redeemed">
            <h2>{formatter.format(totals.redeemed)}</h2>
            <div className="d-flex align-items-center">
              <img
                src="../assets/images/redeemedcash.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>CaterCash Redeemed</label>
            </div>
          </div>

          <div className="cc-item cc-current">
            <h2>{formatter.format(totals.gifted)}</h2>
            <div className="d-flex align-items-center">
              <img
                src="../assets/images/giftedcash.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>CaterCash Gifted</label>
            </div>
          </div>

          <div className="cc-item cc-expired">
            <h2>{formatter.format(totals.expired)}</h2>
            <div className="d-flex align-items-center">
              <img
                src="../assets/images/expired.svg"
                className="img-fluid"
                alt="Icon"
              />
              <label>CaterCash Expired</label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
